<blaze-scroller class="h-full w-full">
  <div class="conversations-list">
    @for (conversation of conversations; track trackById($index, conversation)) {
      <be-chat-list-item
        class="block cursor-pointer"
        data-cy="ConversationsList:item"
        [isSelected]="conversation.id === selectedConversationId"
        [title]="conversation.displayName"
        [imageSrc]="conversation.image"
        [participantCount]="conversation.members.length"
        [unreadCount]="
          selectedConversationId === conversation.id
            ? 0
            : (allConversationsUnreadMessagesCount.get(conversation.id) ?? 0)
        "
        [colorInfo]="conversationsColors[conversation.id || '']"
        [status]="conversation.membersStatuses"
        (selectItem)="selectConversation(conversation)"
      />
    }
  </div>
</blaze-scroller>
